import { FaCommentDots } from "react-icons/fa6";
import { FaHome, FaUserCog } from "react-icons/fa";
import { MdEngineering } from "react-icons/md";

export const staffLinks = [
	{ label: "Inicio", path: "/inicio", icon: FaHome },
	{ label: "Perfil", path: "/perfil", icon: FaUserCog },
	{ label: "Quejas y reportes", path: "/quejasyreportes", icon: FaCommentDots },
	{ label: "Mantenimiento", path: "/Mantenimiento", icon: MdEngineering },
];